import * as React from 'react';

const DonationSmall = () => (
  <svg
    width={50}
    height={44}
    viewBox="0 0 50 44"
    stroke="#1C1F34"
    strokeWidth={2}
    fillRule="evenodd"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round">
    <polygon stroke="none" strokeWidth={1} fill="#E7EBF6" points="3.5 42 29.5 42 29.5 16 3.5 16" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#3A427C"
      d="M29.628,22.5 L3.872,22.5 C3.39,22.5 3,22.052 3,21.5 C3,20.948 3.39,20.5 3.872,20.5 L29.628,20.5 C30.11,20.5 30.5,20.948 30.5,21.5 C30.5,22.052 30.11,22.5 29.628,22.5 Z"
      opacity={0.2}
    />
    <polygon points="3.75 42.25 29.75 42.25 29.75 20.75 3.75 20.75" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#8EAFFF"
      d="M3.814,20.434 L29.938,20.434 L3.814,20.434 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#8EAFFF"
      d="M3.814,20.434 L29.938,20.434 L3.814,20.434 Z"
    />
    <polygon points="2.75 20.865 30.25 20.865 30.25 16.865 2.75 16.865" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M19.651,26.599 C19.651,26.599 23.835,21.836 24.86,17.341 C25.885,12.846 24.426,12.17 21.978,11.709 C19.529,11.248 18.043,10.927 18.495,9.341 C18.946,7.754 21.978,6.292 21.978,6.292 C21.978,6.292 20.243,4.511 22.862,3.103 C25.481,1.694 27.128,1.188 29.339,1.118 C31.55,1.047 32.032,2.528 30.649,3.888 C29.265,5.248 27.712,9.979 31.649,12.589 C35.586,15.199 43.059,18.373 45.184,21.809 C47.308,25.245 48.397,26.695 48.487,32.666 C48.577,38.638 47.25,42.502 40.69,42.502 L29.339,42.502 C29.339,42.502 21.719,42.102 21.719,35.763"
    />
    <path d="M21.977,38.261 C21.977,38.261 23.368,42.399 30.297,42.399 L41.795,42.399 C41.795,42.399 48.503,42.502 48.503,34.91 C48.503,27.318 48.282,22.232 38.994,17.147 C29.707,12.061 29.707,11.324 29.707,7.786 C29.707,4.248 31.55,2.774 31.55,2.774 C31.55,2.774 30.592,1.062 26.98,1.799 C23.368,2.536 20.494,4.616 21.673,6.017 C22.852,7.417 28.454,9.925 28.012,16.41" />
    <path d="M21.405,6.47 C21.405,6.47 18.135,8.386 18.209,10.081 C18.283,11.777 24.4,10.524 25.138,13.767 C25.875,17.01 20.449,26.346 20.449,26.346" />
    <path d="M25.137,13.767 C25.137,13.767 25.693,11.213 30.648,10.905" />
    <path d="M1,42.365 L49,42.365" />
    <polygon
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      points="12 41.615 36 41.615 36 25.615 12 25.615"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#3A427C"
      d="M35.375,32.115 L12.625,32.115 C12.28,32.115 12,31.779 12,31.365 C12,30.951 12.28,30.615 12.625,30.615 L35.375,30.615 C35.72,30.615 36,30.951 36,31.365 C36,31.779 35.72,32.115 35.375,32.115"
      opacity={0.2}
    />
    <polygon points="12.75 42.365 35.25 42.365 35.25 30.365 12.75 30.365" />
    <polygon points="11.75 30.365 36.75 30.365 36.75 26.365 11.75 26.365" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#677BC5"
      d="M27.149,33.955 C26.404,33.21 25.196,33.21 24.452,33.955 L24.217,34.189 L23.983,33.955 C23.238,33.21 22.03,33.21 21.286,33.955 C20.541,34.7 20.541,35.907 21.286,36.652 L21.52,36.886 L23.688,39.054 C23.98,39.346 24.454,39.346 24.747,39.054 L26.914,36.886 L27.149,36.652 C27.894,35.907 27.894,34.7 27.149,33.955"
    />
  </svg>
);

export default DonationSmall;



// WEBPACK FOOTER //
// ./src/assets/images/icons/donation-small.js